import { HotelListFiltersKeyValueViewModel } from '@api/v3';
import Skeleton from '@components/skeletons/Skeleton';

import { DesktopTitle, RegionSkeletonWrapper, Wrapper } from './styled';
import GenericRegionFilter from './GenericRegionFilter';

interface Props {
  title?: string;
  totalItemCount?: number;
  regions?: HotelListFiltersKeyValueViewModel[];
  onCheck: (checkedKeysValue: number[], e: any) => void;
  isLoading?: boolean;
  isError?: boolean;
  isCity?: boolean;
  selectedRegions?: Array<any>;
}

const DesktopRegionFilter = ({
  title,
  totalItemCount,
  regions,
  onCheck,
  isError,
  isLoading,
  isCity,
  selectedRegions,
}: Props) => {
  return (
    <Wrapper>
      <DesktopTitle id='urun-sayisi'>
        {!isLoading
          ? `${totalItemCount ? `${title} (${totalItemCount})` : title}`
          : title}
      </DesktopTitle>

      {isLoading ? (
        <RegionSkeletonWrapper>
          <Skeleton
            width={130}
            height={20}
            marginBottom={10}
            borderRadius={8}
          />
          <Skeleton
            width={110}
            height={20}
            marginBottom={10}
            borderRadius={8}
          />
          <Skeleton
            width={130}
            height={20}
            marginBottom={10}
            borderRadius={8}
          />
          <Skeleton width={110} height={20} borderRadius={8} />
        </RegionSkeletonWrapper>
      ) : null}

      <GenericRegionFilter
        regions={regions}
        onCheck={onCheck}
        isLoading={isLoading}
        isError={isError}
        selectedRegions={selectedRegions}
        isCity={isCity}
      />
    </Wrapper>
  );
};

export default DesktopRegionFilter;
